import { useTranslate } from '@agilepoint/wat-react';
import { Illustartions } from '@agilepoint/web-components';
import { DefaultUploadImages } from '../defaults';
import { UploadImagesFormFields } from '../types';
import { AppLogoTilePreviewLayout } from './app-logo-tile-preview-layout';


export const useAppTileInfo = () => {
    const translate = useTranslate();

    return [{
        headingLabel: translate('modules.createNewApp.steps.uploadImages.appLogoDetails.appLogoforAppHeader'),
        logoTileDetails: [
            {
                imageType: translate('modules.createNewApp.steps.uploadImages.appLogoDetails.imageTypeInfo'),
                imageSize: '550 x 75',
                imagePickerFieldName: UploadImagesFormFields.androidAppLogoHDPIPortrait,
                resetImageURL: DefaultUploadImages.AppLogo
            },
            {
                imageType: translate('modules.createNewApp.steps.uploadImages.appLogoDetails.imageLogoTileInfo'),
                imageSize: '733 x 100',
                imagePickerFieldName: UploadImagesFormFields.androidAppLogoXHDPIPortrait,
                resetImageURL: DefaultUploadImages.AppLogo
            }
        ],
        appIllustrationName: 'maa-android-logo-illustration' as keyof Illustartions
    },
    {
        headingLabel: translate('modules.createNewApp.steps.uploadImages.appLogoIconDetails.logoIconHeader'),
        logoTileDetails: [
            {
                imageType: translate('modules.createNewApp.steps.uploadImages.appLogoDetails.imageTypeInfo'),
                imageSize: '72 x 72',
                imagePickerFieldName: UploadImagesFormFields.androidAppIconHDPIPortrait,
                resetImageURL: DefaultUploadImages.AppIcon
            },
            {
                imageType: translate('modules.createNewApp.steps.uploadImages.appLogoDetails.imageLogoTileInfo'),
                imageSize: '96 x 96',
                imagePickerFieldName: UploadImagesFormFields.androidAppIconXHDPIPortrait,
                resetImageURL: DefaultUploadImages.AppIcon
            },
            {
                imageType: translate('modules.createNewApp.steps.uploadImages.appLogoIconDetails.portraitDetailsLabel'),
                imageSize: '144 x 144',
                imagePickerFieldName: UploadImagesFormFields.androidAppIconXXHDPIPortrait,
                resetImageURL: DefaultUploadImages.AppIcon
            }
        ],
        appIllustrationName: 'maa-android-app-icon-illustration' as keyof Illustartions
    },
    {
        headingLabel: translate('modules.createNewApp.steps.uploadImages.splashScreenAppDetails.splashScreenHeader'),
        logoTileDetails: [
            {
                imageType: translate('modules.createNewApp.steps.uploadImages.appLogoDetails.imageTypeInfo'),
                imageSize: '72 x 72',
                imagePickerFieldName: UploadImagesFormFields.androidSplashScreenHDPIPortrait,
                resetImageURL: DefaultUploadImages.SplashScreenPortraitHDPI
            },
            {
                imageType: translate('modules.createNewApp.steps.uploadImages.appLogoDetails.imageLogoTileInfo'),
                imageSize: '96 x 96',
                imagePickerFieldName: UploadImagesFormFields.androidSplashScreenXHDPIPortrait,
                resetImageURL: DefaultUploadImages.SplashScreenPortraitXHDPI
            },
            {
                imageType: translate('modules.createNewApp.steps.uploadImages.appLogoDetails.xxHDPIPortrait'),
                imageSize: '144 x 144',
                imagePickerFieldName: UploadImagesFormFields.androidSplashScreenXXHDPIPortrait,
                resetImageURL: DefaultUploadImages.SplashScreenPortraitXXHDPI
            }
        ],
        appIllustrationName: 'maa-android-splashscreen-illustration' as keyof Illustartions
    }];
};

export const AndroidTabContent = (props: { menuColor?: string }) => {
    const appTileMetadata = useAppTileInfo();
    return (
        <AppLogoTilePreviewLayout appTileMetadata={appTileMetadata} isAndroid menuColor={props.menuColor} />
    );
};

